export const RESET_CHECKS = 'RESET_CHECKS';
export const UPDATE_CHECKS = 'UPDATE_CHECKS';